import React from 'react';
import { connect } from 'react-redux';
import Awardee from './Awardee';

const Awardees = ({awardees, classname}) => {
    if(awardees.notLoaded) return <div/>
    return awardees && awardees.map((awardee, index) => <Awardee classname={classname} key={awardee.item_id} awardee={awardee} index={index}/>)
}

export default connect(state=>state)(Awardees)